/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpLeftIcon16Regular = forwardRef('ArrowDUturnUpLeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.002.44a.75.75 0 1 1 .996 1.12L3.973 4.25H8.5a5.75 5.75 0 1 1 0 11.5H4.75a.75.75 0 0 1 0-1.5H8.5a4.25 4.25 0 1 0 0-8.5H3.973l3.025 2.69a.75.75 0 1 1-.996 1.12l-3.66-3.252a1.75 1.75 0 0 1 0-2.616L6.003.439Z" })));
});
